// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserManagement-space1-DLG_J {
	margin-bottom: 6px !important;
}

.UserManagement-space2-yLz_u {
	margin-bottom: 12px !important;
}

.UserManagement-space3-mNT22 {
	margin-bottom: 18px !important;
}

.UserManagement-space4-XDxFB {
	margin-bottom: 24px !important;
}

.UserManagement-space5-HnzWZ {
	margin-bottom: 30px !important;
}

.UserManagement-space6-CsU_V {
	margin-bottom: 36px !important;
}

.UserManagement-space7-tKBR9 {
	margin-bottom: 42px !important;
}

.UserManagement-space8-PhT0C {
	margin-bottom: 48px !important;
}

.UserManagement-spaceTop1-VBmfV {
	margin-top: 6px !important;
}

.UserManagement-spaceTop2-lIiPj {
	margin-top: 12px !important;
}

.UserManagement-spaceTop3-pG2Mi {
	margin-top: 18px !important;
}

.UserManagement-spaceTop4-W1YBt {
	margin-top: 24px !important;
}

.UserManagement-spaceTop5-sK_d7 {
	margin-top: 30px !important;
}

.UserManagement-spaceTop6-k_87Q {
	margin-top: 36px !important;
}

.UserManagement-spaceTop7-XhWVw {
	margin-top: 42px !important;
}

.UserManagement-spaceTop8-izDsi {
	margin-top: 48px !important;
}

.UserManagement-noMargin-N2d82 {
	margin: 0px !important;
}

.UserManagement-padding1-XYC6C {
	padding-bottom: 6px !important;
}

.UserManagement-padding2-CzRB1 {
	padding-bottom: 12px !important;
}

.UserManagement-padding3-sznvI {
	padding-bottom: 18px !important;
}

.UserManagement-padding4-eEt_X {
	padding-bottom: 24px !important;
}

.UserManagement-padding5-U7WhO {
	padding-bottom: 30px !important;
}

.UserManagement-padding6-KrQOp {
	padding-bottom: 36px !important;
}

.UserManagement-padding7-SoKcl {
	padding-bottom: 42px !important;
}

.UserManagement-paddingTop1-Qlebf {
	padding-top: 6px !important;
}

.UserManagement-paddingTop2-v4F_Y {
	padding-top: 12px !important;
}

.UserManagement-paddingTop3-VIe3L {
	padding-top: 18px !important;
}

.UserManagement-paddingTop4-yUjbY {
	padding-top: 24px !important;
}

.UserManagement-paddingTop5-e6jCU {
	padding-top: 30px !important;
}

.UserManagement-paddingTop6-f4Ibj {
	padding-top: 36px !important;
}

.UserManagement-paddingTop7-tN4Lv {
	padding-top: 42px !important;
}

.UserManagement-noPadding-vXNRI {
	padding: 0px !important;
}

.UserManagement-spaceMarginBottom0-YUpDs {
	margin-bottom: 0;
}

.UserManagement-textBold-ewJio {
	font-weight: 500 !important;
}

.UserManagement-textBolder-irJF8 {
	font-weight: 700 !important;
}

.UserManagement-textNormal-mQCId {
	font-weight: normal !important;
}

/*New Design Text Colors */

.UserManagement-textDarkBlue-AJkw6 {
	color: rgb(20, 39, 94) !important;
}

.UserManagement-textLightBlue-WmY4m {
	color: rgb(57, 87, 106) !important;
}

.UserManagement-textLightSandleGreen-b3AZa {
	color: rgb(76, 86, 41) !important;
}

.UserManagement-textLightBrown-Rvaga {
	color: rgb(115, 79, 33) !important;
}

.UserManagement-textMediumMaroon-lOIjC {
	color: rgb(87, 37, 51) !important;
}

.UserManagement-textBrown-cpqJ5 {
	color: rgb(160, 47, 24) !important;
}

.UserManagement-textMaroon-Zzsoh {
	color: rgb(155, 49, 67) !important;
}

.UserManagement-textDarkBrown-sJ8Rt {
	color: rgb(83, 18, 16) !important;
}

.UserManagement-textMediumBrown-QEGrF {
	color: rgb(142, 28, 10) !important;
}

.UserManagement-textSkyBlue-GQ6Pt {
	color: rgb(37, 117, 141) !important;
}

.UserManagement-textGray-My7tz {
	color: rgb(77, 65, 51) !important;
}

.UserManagement-errorMessage-ax9zG {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.UserManagement-userText-HqMLJ {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.UserManagement-panelHeader-cPNkx {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.UserManagement-exportSection-LzjLn {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.UserManagement-exportSectionGridSub-Yhozl {
	grid-template-columns: 50% 49% !important;
}

.UserManagement-exportText-ZR7I1 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.UserManagement-exportLinkImg-gPYmv {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.UserManagement-exportImg-vs7zG {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.UserManagement-linkBtn-zidhC {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.UserManagement-table-hRd77 {
	display: table;
}

.UserManagement-tableRow-gUmjl {
	display: table-row;
}

.UserManagement-tableCell-Ysj6W {
	display: table-cell;
	float: none;
}

.UserManagement-formGroup-Wj_OJ {
	margin-bottom: 6px;
}

.UserManagement-marginTop0-_lfcl {
	margin-top: 0;
}

.UserManagement-marginBottom20-dkp9J {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.UserManagement-bannerImageBg-Py7YW {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.UserManagement-bannerDelete-wMp0W {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.UserManagement-exportLink-roaS3 {
	padding-top: 10px;
	padding-right: 10px;
}

.UserManagement-seachContent-Foz6V {
	padding-left: 0px;
	margin-bottom: 5px;
}

.UserManagement-marginBottom9-HqfoS {
	margin-bottom: 9px;
}

.UserManagement-spaceTop52-gu4Ej {
	margin-top: 52px;
}

.UserManagement-profileViewInner-WZNQX {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.UserManagement-profileViewMain-BIeuQ {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.UserManagement-profileViewlabel-P_Spf {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.UserManagement-profileViewMainContent-d1NJY {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.UserManagement-reviewsFormStar-c_niR {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.UserManagement-reviewsFormStar-c_niR svg {
	cursor: pointer;
}

.UserManagement-addLanguageText-ughl2 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.UserManagement-exportSection-LzjLn {
		grid-template-columns: 100%;
	}

	.UserManagement-spaceTop52-gu4Ej {
		margin-top: 18px;
	}

	.UserManagement-exportText-ZR7I1 {
		float: none;
		margin-top: 12px;
	}

	.UserManagement-exportSectionGridSub-Yhozl {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.UserManagement-profileViewlabel-P_Spf {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.UserManagement-profileViewMainContent-d1NJY {
		width: 100%;
		text-align: center;
	}

	.UserManagement-panelHeader-cPNkx {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `UserManagement-space1-DLG_J`,
	"space2": `UserManagement-space2-yLz_u`,
	"space3": `UserManagement-space3-mNT22`,
	"space4": `UserManagement-space4-XDxFB`,
	"space5": `UserManagement-space5-HnzWZ`,
	"space6": `UserManagement-space6-CsU_V`,
	"space7": `UserManagement-space7-tKBR9`,
	"space8": `UserManagement-space8-PhT0C`,
	"spaceTop1": `UserManagement-spaceTop1-VBmfV`,
	"spaceTop2": `UserManagement-spaceTop2-lIiPj`,
	"spaceTop3": `UserManagement-spaceTop3-pG2Mi`,
	"spaceTop4": `UserManagement-spaceTop4-W1YBt`,
	"spaceTop5": `UserManagement-spaceTop5-sK_d7`,
	"spaceTop6": `UserManagement-spaceTop6-k_87Q`,
	"spaceTop7": `UserManagement-spaceTop7-XhWVw`,
	"spaceTop8": `UserManagement-spaceTop8-izDsi`,
	"noMargin": `UserManagement-noMargin-N2d82`,
	"padding1": `UserManagement-padding1-XYC6C`,
	"padding2": `UserManagement-padding2-CzRB1`,
	"padding3": `UserManagement-padding3-sznvI`,
	"padding4": `UserManagement-padding4-eEt_X`,
	"padding5": `UserManagement-padding5-U7WhO`,
	"padding6": `UserManagement-padding6-KrQOp`,
	"padding7": `UserManagement-padding7-SoKcl`,
	"paddingTop1": `UserManagement-paddingTop1-Qlebf`,
	"paddingTop2": `UserManagement-paddingTop2-v4F_Y`,
	"paddingTop3": `UserManagement-paddingTop3-VIe3L`,
	"paddingTop4": `UserManagement-paddingTop4-yUjbY`,
	"paddingTop5": `UserManagement-paddingTop5-e6jCU`,
	"paddingTop6": `UserManagement-paddingTop6-f4Ibj`,
	"paddingTop7": `UserManagement-paddingTop7-tN4Lv`,
	"noPadding": `UserManagement-noPadding-vXNRI`,
	"spaceMarginBottom0": `UserManagement-spaceMarginBottom0-YUpDs`,
	"textBold": `UserManagement-textBold-ewJio`,
	"textBolder": `UserManagement-textBolder-irJF8`,
	"textNormal": `UserManagement-textNormal-mQCId`,
	"textDarkBlue": `UserManagement-textDarkBlue-AJkw6`,
	"textLightBlue": `UserManagement-textLightBlue-WmY4m`,
	"textLightSandleGreen": `UserManagement-textLightSandleGreen-b3AZa`,
	"textLightBrown": `UserManagement-textLightBrown-Rvaga`,
	"textMediumMaroon": `UserManagement-textMediumMaroon-lOIjC`,
	"textBrown": `UserManagement-textBrown-cpqJ5`,
	"textMaroon": `UserManagement-textMaroon-Zzsoh`,
	"textDarkBrown": `UserManagement-textDarkBrown-sJ8Rt`,
	"textMediumBrown": `UserManagement-textMediumBrown-QEGrF`,
	"textSkyBlue": `UserManagement-textSkyBlue-GQ6Pt`,
	"textGray": `UserManagement-textGray-My7tz`,
	"errorMessage": `UserManagement-errorMessage-ax9zG`,
	"userText": `UserManagement-userText-HqMLJ`,
	"panelHeader": `UserManagement-panelHeader-cPNkx`,
	"exportSection": `UserManagement-exportSection-LzjLn`,
	"exportSectionGridSub": `UserManagement-exportSectionGridSub-Yhozl`,
	"exportText": `UserManagement-exportText-ZR7I1`,
	"exportLinkImg": `UserManagement-exportLinkImg-gPYmv`,
	"exportImg": `UserManagement-exportImg-vs7zG`,
	"linkBtn": `UserManagement-linkBtn-zidhC`,
	"table": `UserManagement-table-hRd77`,
	"tableRow": `UserManagement-tableRow-gUmjl`,
	"tableCell": `UserManagement-tableCell-Ysj6W`,
	"formGroup": `UserManagement-formGroup-Wj_OJ`,
	"marginTop0": `UserManagement-marginTop0-_lfcl`,
	"marginBottom20": `UserManagement-marginBottom20-dkp9J`,
	"bannerImageBg": `UserManagement-bannerImageBg-Py7YW`,
	"bannerDelete": `UserManagement-bannerDelete-wMp0W`,
	"exportLink": `UserManagement-exportLink-roaS3`,
	"seachContent": `UserManagement-seachContent-Foz6V`,
	"marginBottom9": `UserManagement-marginBottom9-HqfoS`,
	"spaceTop52": `UserManagement-spaceTop52-gu4Ej`,
	"profileViewInner": `UserManagement-profileViewInner-WZNQX`,
	"profileViewMain": `UserManagement-profileViewMain-BIeuQ`,
	"profileViewlabel": `UserManagement-profileViewlabel-P_Spf`,
	"profileViewMainContent": `UserManagement-profileViewMainContent-d1NJY`,
	"reviewsFormStar": `UserManagement-reviewsFormStar-c_niR`,
	"addLanguageText": `UserManagement-addLanguageText-ughl2`
};
module.exports = ___CSS_LOADER_EXPORT___;
